import { translate } from 'i18n/i18n'
import { isNil } from 'lodash'
import type { TUnitConverterOptionsWithoutUnits, TUnitConverterTypicalReturn } from '../types'

export const cherryPowderyMildew: Record<
  'cherryPowderyMildew',
  (
    cherryPowderyMildewAmount?: number | null,
    options?: TUnitConverterOptionsWithoutUnits,
  ) => TUnitConverterTypicalReturn
> = {
  cherryPowderyMildew: (
    cherryPowderyMildew: number | null = null,
    {
      decimalPlaces,
    }: {
      decimalPlaces?: number
    } = {},
  ) => {
    const defaultNumberOfDecimalPlaces = 0

    let convertedValue: number | null

    if (isNil(cherryPowderyMildew)) {
      convertedValue = null
    } else {
      convertedValue = Number(cherryPowderyMildew)
    }

    const categoryTitle = translate.phrases.banyanApp('Cherry Powdery Mildew')
    const decimalPlacesToUse = decimalPlaces ?? defaultNumberOfDecimalPlaces

    const label = translate.phrases.banyanApp('{{diseaseName}} Secondary Infection Risk Index', {
      diseaseName: categoryTitle,
    })

    return {
      categoryTitle: () => categoryTitle,
      categoryTitleWithoutUnit: () => categoryTitle,
      defaultNumberOfDecimalPlaces: () => defaultNumberOfDecimalPlaces,
      suffix: () => '',
      shortTitle: () => categoryTitle,
      title: () => label,
      titleWithoutUnit: () => label,
      value: () => {
        if (isNil(convertedValue)) return null

        return +convertedValue?.toFixed(decimalPlacesToUse)
      },
      valueAsString: () => {
        if (isNil(convertedValue)) return translate.phrases.templates('-')

        return convertedValue?.toFixed(decimalPlacesToUse)
      },
      valueWithSuffix: () =>
        translate.measurements.diseaseSeverityValue.value(convertedValue, decimalPlacesToUse),
      valueWithNoRounding: () => convertedValue,
    }
  },
}
